var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaticCircular = function SvgMaticCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 1.4,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    fill: "#7630EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.704 11.668c-.263-.143-.601-.143-.902 0l-2.106 1.175-1.428.748-2.068 1.175c-.263.142-.602.142-.903 0l-1.616-.926a.86.86 0 0 1-.451-.748v-1.78c0-.285.15-.57.45-.748l1.617-.89c.264-.143.602-.143.903 0l1.616.925a.86.86 0 0 1 .452.748v1.175l1.428-.783v-1.21c0-.286-.15-.57-.45-.749l-3.009-1.673c-.263-.143-.601-.143-.902 0L7.252 9.816a.778.778 0 0 0-.451.712v3.347c0 .285.15.57.451.748l3.045 1.674c.264.142.602.142.903 0l2.068-1.14 1.428-.783 2.068-1.14c.263-.142.602-.142.903 0l1.616.89a.86.86 0 0 1 .451.748v1.78c0 .286-.15.57-.45.749l-1.58.89c-.263.142-.601.142-.902 0l-1.617-.89a.86.86 0 0 1-.451-.748v-1.14l-1.429.784v1.175c0 .285.15.57.451.748l3.046 1.673c.263.143.601.143.902 0l3.046-1.673a.86.86 0 0 0 .45-.748v-3.383c0-.285-.15-.57-.45-.748l-3.046-1.673Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 1.4,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    stroke: "#fff",
    strokeWidth: 1.2
  })));
};
export default SvgMaticCircular;